import { IndicationsAgentResponse } from '@/models/backoffice/indications'
import api from '@/services/api'

import { normalizeText } from './normalize-text'

interface getIndicationsByIdProps {
  agentId: string
  params?: string
  queryParam?: {
    resourceName: string
    referralStatus: string
    referralType: string
  }
}
export async function getIndicationsByAgentId({
  agentId,
  params,
  queryParam,
}: getIndicationsByIdProps) {
  if (params && queryParam !== undefined) {
    const { resourceName, referralStatus, referralType } = queryParam
    const normalizedParams = params.replace(/^&/, '?')
    return await api.get<IndicationsAgentResponse[]>(
      `/agent/referral/${agentId}${normalizedParams}&resourceName=${normalizeText(resourceName)}&referralStatus=${referralStatus}&referralType=${referralType}`,
    )
  }

  if (params) {
    const normalizedParams = params.replace(/^&/, '?')
    return await api.get<IndicationsAgentResponse[]>(
      `/agent/referral/${agentId}${normalizedParams}`,
    )
  }

  if (queryParam !== undefined) {
    const { resourceName, referralStatus, referralType } = queryParam
    return await api.get<IndicationsAgentResponse[]>(
      `/agent/referral/${agentId}?resourceName=${normalizeText(resourceName)}&referralStatus=${referralStatus}&referralType=${referralType}`,
    )
  }

  return await api.get<IndicationsAgentResponse[]>(`/agent/referral/${agentId}`)
}
